import { render } from "./productPriceRange.vue?vue&type=template&id=15698238"
import script from "./productPriceRange.vue?vue&type=script&lang=js"
export * from "./productPriceRange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/AlbbPublishProduct/components/productPriceRange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15698238"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15698238', __exports__)) {
    api.reload('15698238', __exports__)
  }
  
  module.hot.accept("./productPriceRange.vue?vue&type=template&id=15698238", () => {
    api.rerender('15698238', render)
  })

}


export default __exports__